import { Typography } from "@/core/components/ui/typography";
import { cn } from "@/core/utils/utils";

export const PageHeader = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <Typography className={cn("text-2xl font-bold", className)}>
    {children}
  </Typography>
);
